<template>
    <v-btn
      class="v-btn--bottom v-btn--fixed v-btn--right"
      :title="$t('Create new article')"
      color="primary"
      style="z-index: 1;"
      to="private/articles/create"
    >
      {{ $t("Create new article") }}
    </v-btn>
</template>

<script>
// Import the i18n export file
import messages from "../../../modules/lang/main/export";
export default {
  // Use it in this file
  i18n: { messages },
  data(){
    return{

    }
  }
}
</script>